var path = 'app/scripts/modules/core/src/deploymentStrategy/strategies/custom/additionalFields.html';
var html = "<custom-strategy-selector command=\"$ctrl.command\"></custom-strategy-selector>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/deploymentStrategy/strategies/custom/additionalFields.html
// module id = 981
// module chunks = 0